import { GoldLogo } from "./ItemCard";
import { ItemLink } from "../ItemLink";
import { HeaderBullet } from "@ugg/shared/components/common/HeaderBullet";
import type { Item } from "@outplayed/riot-assets";

interface ItemStatsRecipeProps {
  itemId: number;
  itemData: Item;
}

export function ItemStatsRecipe(props: ItemStatsRecipeProps) {
  const { itemId, itemData } = props;

  if (!itemId || !itemData) return null;

  const from = itemData.from;

  const plusIcon = "https://static.bigbrain.gg/assets/ugg/icons/plus.svg";

  return (
    <div className="items-details-section">
      <HeaderBullet className="mb-[18px]">Recipe</HeaderBullet>
      {from && (
        <div className="stats-recipe-components">
          {from?.map((id, index) => (
            <div className="recipe-img-container" key={`${id}-${index}`}>
              <ItemLink itemId={parseInt(id)} className="recipe-img items-pic-30 items-border-normal-small" />
              <img src={plusIcon} alt="" className="plus-icon" />
            </div>
          ))}
          <GoldLogo cost={itemData.gold?.base} />
        </div>
      )}

      <div className="stats-recipe-info">
        <div className="stats-recipe-data">
          <span className="recipe-title">Cost</span>
          <GoldLogo cost={itemData.gold?.total} />
        </div>
        <div className="stats-recipe-data">
          <span className="recipe-title">Sell</span>
          <GoldLogo cost={itemData.gold?.sell} />
        </div>
        <div className="stats-recipe-data">
          <span className="recipe-title">ID</span>
          <span>{itemId}</span>
        </div>
      </div>
    </div>
  );
}
